module.exports = __webpack_public_path__ + "static/img/ts_case_pic2.fb00e9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ts_case_pic2.jpg
// module id = 63rU
// module chunks = 1